import {Filter} from '../core/filter/filter';
import {AccountType} from '../model/account';

export class ClientAccountFilter extends Filter {
  public text?: string;
  public level?: number;
  public type?: AccountType;
}
